import type {CopilotSpaceResource} from '../../types'
import {FileIcon, GitPullRequestIcon, ImageIcon, IssueOpenedIcon, PasteIcon, RepoIcon} from '@primer/octicons-react'

interface AttachmentIconProps {
  attachment: CopilotSpaceResource
  className?: string
}

export function AttachmentIcon({attachment, className}: AttachmentIconProps) {
  switch (attachment.type) {
    case 'github_file':
      return <FileIcon className={className} />
    case 'free_text':
      return <PasteIcon className={className} />
    case 'uploaded_text_file':
      return <FileIcon className={className} />
    case 'github_issue':
      return <IssueOpenedIcon className={className} />
    case 'github_pull_request':
      return <GitPullRequestIcon className={className} />
    case 'media_content':
      return <ImageIcon className={className} />
    case 'repository':
      return <RepoIcon className={className} />
    default:
      return null
  }
}
